import { Label } from '@kit/ui/label';
import { RadioGroupItem } from '@kit/ui/radio-group';
import { Trans } from '@kit/ui/trans';
import { cn } from '@kit/ui/utils';

import { ImageCarousel } from '../../_components/image-carousel';
import styles from './native-booking-controls.module.css';

export default function CourtItem({
  court,
  id,
  value,
  courtType,
  images,
  disabled = false,
}: {
  court: string;
  id: string;
  value: string;
  courtType?: string;
  /** Gallery image URLs (courts.image_urls). When non-empty the card renders
   *  an image-on-top layout with a carousel; otherwise the text-only card. */
  images?: string[] | null;
  disabled?: boolean;
}) {
  const hasImages = (images?.length ?? 0) > 0;

  if (hasImages) {
    return (
      <div className="relative">
        <RadioGroupItem
          value={value}
          id={id}
          className="peer sr-only"
          disabled={disabled}
        />
        <Label
          htmlFor={id}
          className={cn(
            styles.courtOption,
            'border-input bg-background hover:bg-accent peer-data-[state=checked]:border-primary peer-data-[state=checked]:ring-primary [&:has([data-state=checked])]:border-primary flex flex-col overflow-hidden rounded-lg border transition-all duration-200 peer-data-[state=checked]:ring-2 peer-data-[state=checked]:ring-inset',
            disabled
              ? 'hover:bg-background cursor-not-allowed opacity-50'
              : 'cursor-pointer',
          )}
        >
          {/* A grid over every available court — no preload hints. */}
          <ImageCarousel images={images!} alt={court} priority={false} />
          <div className="flex flex-col items-center justify-center p-3 text-center">
            <span className="text-base font-bold md:text-lg">{court}</span>
            {courtType && (
              <span className="text-muted-foreground mt-1 text-center text-xs font-medium tracking-wide uppercase">
                {courtType}
              </span>
            )}
            {disabled && (
              <span className="text-destructive mt-1 text-xs font-medium">
                <Trans i18nKey="bookings:courtUnavailable" />
              </span>
            )}
          </div>
        </Label>
      </div>
    );
  }

  return (
    <div className="relative">
      <RadioGroupItem
        value={value}
        id={id}
        className="peer sr-only"
        disabled={disabled}
      />
      <Label
        htmlFor={id}
        className={cn(
          styles.courtOption,
          'border-input bg-background hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary peer-data-[state=checked]:bg-primary/5 [&:has([data-state=checked])]:border-primary [&:has([data-state=checked])]:bg-primary/5 flex min-h-[80px] flex-col items-center justify-center rounded-lg border p-3 transition-all duration-200 md:min-h-[100px] md:p-4',
          disabled
            ? 'hover:bg-background hover:text-muted-foreground cursor-not-allowed opacity-50'
            : 'cursor-pointer',
        )}
      >
        <span className="text-center text-base font-bold md:text-lg">
          {court}
        </span>
        {courtType && (
          <span className="text-muted-foreground mt-1 text-center text-xs font-medium tracking-wide uppercase">
            {courtType}
          </span>
        )}
        {disabled && (
          <span className="text-destructive mt-1 text-xs font-medium">
            <Trans i18nKey="bookings:courtUnavailable" />
          </span>
        )}
      </Label>
    </div>
  );
}
